import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09c0cea6&"
import script from "./documents.component.js?vue&type=script&lang=js&"
export * from "./documents.component.js?vue&type=script&lang=js&"
import style0 from "./documents.style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports